import styled, { css } from 'styled-components';
import color from 'tinycolor2';

import {
  Button as ButtonComponent,
  Menu as MenuComponent,
  MenuListItem,
} from '@pearsontechnology/aero-components';

export const ModalOverlay = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  overflow-y: ${(props) => props.status === 'entered' ? 'auto' : 'hidden'};;
  overflow-x: hidden;
  padding: 20px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px;
  }
`;

export const ModalBackDrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.4s ease;
  opacity: ${(props) => (props.status === 'entering' || props.status === 'entered') ? 1 : 0};
  z-index: -1;
`;

export const ModalSurface = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: auto;
  background: ${(props) => props.theme['color.surface']};
  box-shadow: ${(props) => props.theme['shadow.modal']};
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  border-radius: 4px;
  max-width: ${(props) => props.maxWidth ? props.maxWidth : '400px'};
  width: 100%;
  transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: ${(props) => (props.status === 'entering' || props.status === 'entered') ? 1 : 0};
  transform: ${(props) => (props.status === 'entering' || props.status === 'entered')
    ? 'scale3d(1, 1, 1)'
    : 'scale3d(1.2, 1.2, 1)'};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px 30px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px 20px;
  }
`;

export const ModalHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 50%;
  margin-right: 10px;
  margin-left: -6px;
  background: ${(props) => props.iconColor
    ? color(props.iconColor).setAlpha(0.2).toString()
    : color(props.theme['color.primary']).setAlpha(0.2).toString()};
  color: ${(props) => props.iconColor
    ? props.iconColor
    : props.theme['color.primary']};

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    display: none;
  }
`;

export const ModalTitle = styled.h1`
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
  color: ${(props) => props.theme['color.text.title']};
  margin: 0;
  min-height: 36px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 88%;
  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    font-size: 18px;
  }
`;

export const ModalCloseWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    top: 10px;
    right: 10px;
  }
`;

export const ModalMenuWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 70px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    top: 10px;
    right: 10px;
  }
`;

export const ModalContent = styled.div`
  padding: 30px;

  ${ModalHeader} + & {
    padding-top: 0;
  }

  ${(props) => props.unpadBottom && `
    padding-bottom: 0;
  `}

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 20px;
  }
`;

export const ModalBodyText = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme['color.text']};
  line-height: 1.4;
  margin: 0;

  & + & {
    margin-top: 14px;
  }
`;

export const ModalActions = styled.div`
  padding: 30px;
  display: flex;
  justify-content: flex-end;
  grid-gap: 16px;
  grid-auto-flow: column;
  position: relative;

  ${ModalContent} + & {
    padding-top: 0;
  }

  ${(props) => props.scrim && css`
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;

    &::before {
      content: '';
      position: absolute;
      top: -30px;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: none;
      border-radius: 0 0 4px 4px;
      background: linear-gradient(
        ${color(props.theme['color.surface']).setAlpha(0).toString()} 0%,
        ${color(props.theme['color.surface']).setAlpha(0.7).toString()} 48%,
        ${color(props.theme['color.surface']).setAlpha(0.9).toString()} 70%,
        ${props.theme['color.surface']} 100%
      );
    }
  `}

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 20px;
  }
`;

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  width: 100%;
`;

export const StyledMenuListItem = styled(MenuListItem)`
  width:100px;
`;

export const MenuListItemText = styled.div`
  margin: 0 4px;
  font-style:bold;
`;

export const Button = styled(ButtonComponent)`
  color: rgba(255,255,255,0.8);
  background: none;
  padding: 0;
  height: 26px;
  &:hover, &:active, &:focus {
    background: rgba(255, 255, 255, 0.2);
  }
`;
